import useCustomCss from './custom-css'

export default {
    useCustomCss,
}
